import React, { PropsWithChildren, useState } from 'react';
import BillingModal from './BillingModal';

export default function Billing({
  children,
}: PropsWithChildren<{ className?: string }>) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div onClick={() => setOpen(true)}>{children}</div>
      <BillingModal open={open} close={() => setOpen(false)} />
    </>
  );
}
